import React, { useState } from 'react'
import PropTypes from 'prop-types'

import classnames from 'classnames'

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Paragraph,
  Title
} from '@omnilert/components'

import useStyles from './card-accordion.style'

const CardAccordion = ({ className, collapsable }) => {
  const classes = useStyles()
  const { data, title } = collapsable

  const [isOpen, setIsOpen] = useState(false)

  const handleOnOpen = () => setIsOpen(true)

  const handleOnClose = () => setIsOpen(false)

  return (
    <div className={classnames([classes.accordionWrapper, { [className]: !!className }])}>
      <Accordion
        onClose={handleOnClose}
        onOpen={handleOnOpen}
      >
        <AccordionSummary>
          <Title
            className={classes.summaryText}
            color='var(--accordion--text__color)'
            size='sm'
          >{title}
          </Title>
        </AccordionSummary>
        {isOpen && <div className={classes.divider} />}
        <AccordionDetails className={classes.details}>
          {data.map(({ label, text }, i) => (
            <div
              key={i}
              className={classes.text}
            >
              <Title
                className={classes.titleText}
                color='var(--card--text__color)'
                size='sm'
              >{label}
              </Title>
              <Paragraph
                color='var(--card--text__color)'
                size='md'
              >{text || 'Not Provided'}
              </Paragraph>
            </div>
          ))}
        </AccordionDetails>
      </Accordion>
    </div>
  )
}

CardAccordion.defaultProps = {
  collapsable: {
    data: [],
    title: ''
  }
}

CardAccordion.propTypes = {
  collapsable: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({})),
    title: PropTypes.string
  })
}

export default CardAccordion
